import { memo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import {
  isExistAnyInfertilityData,
  itemSettingStyle,
  lineHeightStyle,
  isHiddenInPrint,
  itemTitleStyle
} from '../../../../utils/helpers';
import CommonDeleteBtn from '../commonDeleteBtn';

const Infertility = ({
  element,
  isHistoryPage,
  setShowInfertility,
  selectedInfertilities,
  setSelectedInfertilities,
}) => {
  const userInfo = useSelector((state) => state.authReducer.data);
  let { man, woman } = selectedInfertilities || {};
  const prescriptionItems = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.prescriptionItems,
  );
  const deleteData = (type, itemName) => {
    selectedInfertilities[type] = selectedInfertilities[type]?.filter(
      (item) => item.name !== itemName,
    );
    setSelectedInfertilities({ ...selectedInfertilities });
  };
  const itemPosition = prescriptionItems?.items?.infertility?.position;

  return (
    <div
      className={`row item-row d-block ${
        isExistAnyInfertilityData(selectedInfertilities)
          ? 'data-item-history'
          : 'no-data-item-history'
      }`}
      key={`infertility`}
    >
      <span
        className={`prescription-item ${
          isHiddenInPrint(prescriptionItems, 'infertility')
            ? 'item-title-hide'
            : ''
        }`}
        style={itemTitleStyle(
          prescriptionItems?.items?.['infertility']?.itemStyle || {},
        )}
        {...(!isHistoryPage
          ? {
              onClick: (e) => {
                e.stopPropagation();
                setShowInfertility(true);
              },
            }
          : {})}
      >
        {element?.alterName?.length ? (
          <span>{element?.alterName}</span>
        ) : (
          <span>Infertility</span>
        )}
      </span>
      <div className="infertility-view">
        {itemPosition === 'right' && (
          <Row>
            {woman?.length > 0 && (
              <Col className={man?.length ? 'border-right' : ''}>
                <div className="title">For Woman</div>
                <ul
                  className="sub-child-list"
                  style={lineHeightStyle('referred-to', prescriptionItems)}
                >
                  {woman?.map((item, index) => {
                    return (
                      <li key={index}>
                        <div>
                          <span
                            style={itemSettingStyle(
                              prescriptionItems?.items?.['infertility']
                                ?.itemStyle || {},
                            )}
                          >
                            <span className="text-left">{item.name}</span>
                            {item.result && (
                              <span className="pl-2">- {item.result}</span>
                            )}
                          </span>
                          {!isHistoryPage && (
                            <CommonDeleteBtn
                              action={deleteData}
                              itemName={'woman'}
                              delId={item.name}
                            />
                          )}
                        </div>
                        {item.instruction && (
                          <div>
                            <span
                              className="pl-2 pr-5"
                              style={itemSettingStyle(
                                prescriptionItems?.items?.['infertility']
                                  ?.subItemStyle || {},
                              )}
                            >
                              <i>- {item.instruction}</i>
                            </span>
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </Col>
            )}
            {man?.length > 0 && (
              <Col className="pl-4">
                <div lassName="title">For Man</div>
                <ul
                  className="sub-child-list"
                  style={lineHeightStyle('referred-to', prescriptionItems)}
                >
                  {man?.map((item, index) => {
                    return (
                      <li key={index}>
                        <div>
                          <span
                            style={itemSettingStyle(
                              prescriptionItems?.items?.['infertility']
                                ?.itemStyle || {},
                            )}
                          >
                            <span className="text-left">{item.name}</span>
                            {item.result && (
                              <span className="pl-2">- {item.result}</span>
                            )}
                          </span>
                          {!isHistoryPage && (
                            <CommonDeleteBtn
                              action={deleteData}
                              itemName={'man'}
                              delId={item.name}
                            />
                          )}
                        </div>
                        {item.instruction && (
                          <div>
                            <span
                              className="pl-2 pr-5"
                              style={itemSettingStyle(
                                prescriptionItems?.items?.['infertility']
                                  ?.subItemStyle || {},
                              )}
                            >
                              <i>- {item.instruction}</i>
                            </span>
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </Col>
            )}
          </Row>
        )}
        {itemPosition === 'left' && (
          <>
            {woman?.length > 0 && <div className="title">For Woman</div>}
            <ul className="sub-child-list" style={{ marginBottom: '0.2rem' }}>
              {woman?.map((item, index) => {
                return (
                  <li key={index}>
                    <div>
                      <span
                        style={itemSettingStyle(
                          prescriptionItems?.items?.['infertility']
                            ?.itemStyle || {},
                        )}
                      >
                        <span className="text-left">{item.name}</span>
                        {item.result && (
                          <span className="pl-2">- {item.result}</span>
                        )}
                      </span>
                      {!isHistoryPage && (
                        <CommonDeleteBtn
                          action={deleteData}
                          itemName={'woman'}
                          delId={item.name}
                        />
                      )}
                    </div>
                    {item.instruction && (
                      <div>
                        <span
                          className="pl-2 pr-5"
                          style={itemSettingStyle(
                            prescriptionItems?.items?.['infertility']
                              ?.subItemStyle || {},
                          )}
                        >
                          <i>- {item.instruction}</i>
                        </span>
                      </div>
                    )}
                  </li>
                );
              })}
              {man?.length > 0 && <span className="separator"></span>}
            </ul>

            {man?.length > 0 && <div className="title">For Man</div>}
            <ul className="sub-child-list">
              {man?.map((item, index) => {
                return (
                  <li key={index}>
                    <div>
                      <span
                        style={itemSettingStyle(
                          prescriptionItems?.items?.['infertility']
                            ?.itemStyle || {},
                        )}
                      >
                        <span className="text-left">{item.name}</span>
                        {item?.result && (
                          <span className="pl-2">
                            - <i>{item.result}</i>
                          </span>
                        )}
                      </span>
                      {!isHistoryPage && (
                        <CommonDeleteBtn
                          action={deleteData}
                          itemName={'man'}
                          delId={item.name}
                        />
                      )}
                    </div>
                    {item.instruction && (
                      <div>
                        <span
                          className="pl-2 pr-5"
                          style={itemSettingStyle(
                            prescriptionItems?.items?.['infertility']
                              ?.subItemStyle || {},
                          )}
                        >
                          <i>- {item.instruction}</i>
                        </span>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </>
        )}
      </div>
    </div>
  );
};

export default memo(Infertility);
